import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { CursoExternoEditor, CursosExternosList } from '../../../common/cursosExternos';
import { CursoExterno } from '../../../../service/types/cursosExternos.types';
import { UserService } from '../../../../service/users.service';

type Seleccion = { modo: 'lista' } | { modo: 'nuevo' } | { modo: 'editar'; curso: CursoExterno };

export default function CursosExternosAdmin() {
  const [seleccion, setSeleccion] = useState<Seleccion>({ modo: 'lista' });

  return (
    <Container fluid className="p-4">
      <h3>Gestión de Cursos Externos</h3>
      {seleccion.modo === 'lista' && (
        <CursosExternosList
          onSelectCurso={(curso) => setSeleccion({ modo: 'editar', curso })}
          onCreateNew={() => setSeleccion({ modo: 'nuevo' })}
        />
      )}
      {seleccion.modo !== 'lista' && (
        <>
          <Button variant="link" className="ps-0 mb-2" onClick={() => setSeleccion({ modo: 'lista' })}>
            &larr; Volver a la lista de cursos externos
          </Button>
          <CursoExternoEditor
            key={seleccion.modo === 'editar' ? seleccion.curso.id : 'nuevo'}
            cursoExternoId={seleccion.modo === 'editar' ? seleccion.curso.id : undefined}
            initialValue={seleccion.modo === 'editar' ? seleccion.curso : undefined}
            fetchUsers={UserService.find}
          />
        </>
      )}
    </Container>
  );
}
